import {CAMBRIDGE, ECOACH, IELTS, TOEIC, IELTS_CAMBRIDGE, ANU, MENTER_ENGLISH_MASTERY} from "../config/center/centerOption";

/**
 * Get short link
 * @param center_id
 * @param uuid
 * @param uuid_secret
 * @returns {(void|*)[]}
 */
export function changeLinkCommon(center_id, uuid, uuid_secret) {
    let url_copy = '';
    let url_confirm_contract = '';
    switch (center_id) {
        case ECOACH:
            url_copy = `${process.env.VUE_APP_BASE_URL_ECOACH}/xac-thuc?code=${uuid}`;
            url_confirm_contract = `${process.env.VUE_APP_BASE_URL_ECOACH}/xac-thuc?code=${uuid}&check=${uuid_secret}`;
            break;
        case IELTS:
        case CAMBRIDGE:
        case MENTER_ENGLISH_MASTERY:
            url_copy = `${process.env.VUE_APP_BASE_URL_IELTS}/xac-thuc?code=${uuid}`;
            url_confirm_contract = `${process.env.VUE_APP_BASE_URL_IELTS}/xac-thuc?code=${uuid}&check=${uuid_secret}`;
            break;
        case TOEIC:
            url_copy = `${process.env.VUE_APP_BASE_URL_TOEIC_MASTER}/login?code=${this.contract.uuid}`;
            url_confirm_contract = `${process.env.VUE_APP_BASE_URL_TOEIC_MASTER}/contract?code=${uuid}&check=${uuid_secret}`;
            break;
        case IELTS_CAMBRIDGE:
            url_copy = `${process.env.VUE_APP_BASE_URL_IELTS}/xac-thuc?code=${uuid}`;
            url_confirm_contract = `${process.env.VUE_APP_BASE_URL_IELTS}/xac-thuc?code=${uuid}&check=${uuid_secret}`;
            break;
        case ANU:
            url_copy = `${process.env.VUE_APP_BASE_URL_ANU}/xac-thuc?code=${uuid}`;
            url_confirm_contract = `${process.env.VUE_APP_BASE_URL_ANU}/xac-thuc?code=${uuid}&check=${uuid_secret}`;
            break;
    }
    alert(url_copy)
    return [
        url_copy,
        url_confirm_contract
    ]
}

export const GIFT_LIMIT_MESSAGE = 'Mỗi hợp đồng chỉ được chọn một bộ quà tặng tại một thời điểm.';

/**
 * Lấy danh sách id bộ quà tặng đang chọn của hợp đồng
 * @param contract
 * @returns {string[]}
 */
export function getSelectedGiftIds(contract) {
    const giftIds = Array.isArray(contract?.gift_id) ? contract.gift_id : [];
    return [...new Set(
        giftIds
            .map((gift) => (gift && typeof gift === 'object' ? gift.id : gift))
            .filter((id) => id !== null && id !== undefined && id !== '')
            .map((id) => String(id))
    )];
}

/**
 * Mỗi hợp đồng chỉ được chọn 1 bộ quà tặng tại một thời điểm
 * @param contract
 * @returns {boolean}
 */
export function isGiftLimitExceeded(contract) {
    return getSelectedGiftIds(contract).length > 1;
}
